import { gql } from "@apollo/client";

export const GET_MANDATE_PAFINATION = gql`
  query GetMandatePagination(
    $page: Int
    $limit: Int
    $keyword: String
    $pagination: Boolean
  ) {
    getMandatePagination(
      page: $page
      limit: $limit
      keyword: $keyword
      pagination: $pagination
    ) {
      data {
        _id
        mandateName
        startDate
        endDate
        remark
        isActive
        totalMember
        totalParty
        parties {
          _id
          partyName
          logo
          remark
        }
      }
      paginator {
        slNo
        prev
        next
        perPage
        totalPosts
        totalPages
        currentPage
        hasPrevPage
        hasNextPage
        totalDocs
      }
    }
  }
`;

export const CREATE_MANDATE = gql`
  mutation CreateMandate($input: MandateInput) {
    createMandate(input: $input) {
      isSuccess
      message {
        messageKh
        messageEn
      }
    }
  }
`;

export const UPDATE_MANDATE = gql`
  mutation UpdateMandate($id: ID!, $input: MandateInput) {
    updateMandate(_id: $id, input: $input) {
      isSuccess
      message {
        messageKh
        messageEn
      }
    }
  }
`;

export const DELETE_MANDATE = gql`
  mutation DeleteMandate($id: ID!) {
    deleteMandate(_id: $id) {
      isSuccess
      message {
        messageKh
        messageEn
      }
    }
  }
`;

export const UPDATE_MANDATE_STATUS = gql`
  mutation UpdateMandateStatus($id: ID!, $isActive: Boolean) {
    updateMandateStatus(_id: $id, isActive: $isActive) {
      isSuccess
      message {
        messageKh
        messageEn
      }
    }
  }
`;

export const GET_MANDATE_BY_ID = gql`
  query GetMandateById($id: ID!) {
    getMandateById(_id: $id) {
      _id
      mandateName
      startDate
      endDate
      isActive
      remark
      totalMember
      parties {
        _id
        logo
        remark
        partyName
      }
    }
  }
`;

export const UPDATE_PARTY_IN_MANDATE = gql`
  mutation UpdatePartyInMandate($id: ID!, $numbering: Int) {
    updatePartyInMandate(_id: $id, numbering: $numbering) {
      isSuccess
      message {
        messageKh
        messageEn
      }
    }
  }
`;
